import {  NameTagsStore } from '../../models/nametagsClass';

const initialState: NameTagsStore =
  {
    nameTags: [],
  };

  export const SET_NAMETAGS = 'SET_NAMETAGS';

export const NameTagsReducer = (state = initialState, action) => {
  switch (action.type) {


    case SET_NAMETAGS: {
      return { ...state, nameTags: action.payload};
    }

    default:
      return state;
  }
};
